import { MutableRefObject, useRef } from 'react';

/**
 * returns a ref which always contains the value
 * useful when the value is used in a useCallback etc.
 */
export function useRefWithCurrentValue<T>(value: T): MutableRefObject<T> {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}
